<div class="custom-tooltip {{ classList }} h-{{horizontalAnim}} v-{{verticalAnim}}" *ngIf="!customTooltipDisabled" [@customToolTipAnim]>
    <ng-template #simpleText>
        {{ text }}
    </ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText"> </ng-container>
</div>
